import { computed, renderSlot, normalizeProps, guardReactiveProps, unref, openBlock, createBlock, resolveDynamicComponent, mergeProps, withCtx } from 'vue';
import { u as useFormKitSection } from './useFormKitSection-0P94qXKh.js';
import { k as kebab } from './kebab-_XTA8qsc.js';

const _sfc_main = /*#__PURE__*/Object.assign({
  inheritAttrs: false,
}, {
  __name: 'Section',
  props: {
  sectionKey: {
    type: String,
    required: true,
  },
  as: {
    type: String,
    default: 'div',
  },
  withId: Boolean,
  id: String,
  classKey: {
    type: String,
  },
  context: Object,
},
  setup(__props) {


const { context: propsContext, sectionKey, as, classKey } = __props;
const { context: injectContext, classes, defaultSlotComponent } = useFormKitSection({ sectionKey, classKey });

const context = computed(() => injectContext || propsContext);

return (_ctx, _cache) => {
  return renderSlot(_ctx.$slots, __props.sectionKey, normalizeProps(guardReactiveProps({ context: context.value, defaultSlotComponent: unref(defaultSlotComponent) })), () => [
    (openBlock(), createBlock(resolveDynamicComponent(__props.as), mergeProps({
      id: !__props.id && !__props.withId ? undefined : __props.id || `${unref(kebab)(__props.sectionKey)}-${context.value.id}`,
      class: unref(classes)
    }, _ctx.$attrs), {
      default: withCtx(() => [
        renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 16, ["id", "class"]))
  ])
}
}

});

export { _sfc_main as _ };
//# sourceMappingURL=Section-BiYiX0EU.js.map
